// @flow
import type { Uploader } from "uploader";
import { types as ats } from "../store/actions";
import { selectActiveQueueMeta } from "../store/selectors";

/**
 * dispatch action if cloud name changed - to fetch cloud info for new name
 */
export default (newState: Object, prevState: Object, uploader: Uploader, actions: Object) => {
	const newQueue = selectActiveQueueMeta(newState);
	const newCloudName = newQueue && newQueue.config.cloudName;
	const prevQueue = newQueue && selectActiveQueueMeta(prevState);

	if (newQueue && newCloudName && (!prevQueue
        || newCloudName !== prevQueue.config.cloudName)) {
		actions[ats.UPDATE_CLOUD_INFO]({ config: newQueue.config });
	}
};
